// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"142":"68c54faa","413":"e6ebd051"}[chunkId] + ".chunk.js");